import React from 'react';

// Local replacement for gatsby-plugin-google-gtag's OutboundLink: an <a> that
// fires a Google Analytics "outbound" click event before navigating. It uses the
// global gtag (defined by the consent plugin's Consent Mode default and processed
// by GTM once consent loads it), so no separate gtag package is needed. beacon
// transport ensures the event is sent even when the click navigates the page away.
const OutboundLink = ({ href, onClick, children, ...rest }) => (
  <a
    href={href}
    onClick={(e) => {
      if (typeof onClick === 'function') onClick(e);
      if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        window.gtag('event', 'click', {
          event_category: 'outbound',
          event_label: href,
          transport_type: 'beacon',
        });
      }
    }}
    {...rest}
  >
    {children}
  </a>
);

export default OutboundLink;
